import script from "./QnaWritingFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QnaWritingFormModal.vue?vue&type=script&setup=true&lang=js"

import "./QnaWritingFormModal.vue?vue&type=style&index=0&id=ed4eb0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed4eb0b8"]])

export default __exports__